export const LogoMark = ({ size = 36 }) => (
  <img
    src="/fairfox-logo.png"
    alt="Fairfox logo"
    data-testid="logo-mark"
    style={{ height: size, width: "auto" }}
    className="object-contain"
  />
);

export const Logo = ({ onClick }) => (
  <a
    href="#top"
    data-testid="nav-logo"
    onClick={onClick}
    className="flex flex-col leading-none group"
  >
    <span className="font-display text-xl font-semibold tracking-[0.22em] gold-text">EON FAIRFOX</span>
    <span data-testid="nav-operator-disclosure" className="mt-1.5 max-w-[210px] font-sans text-[8px] font-light leading-[1.3] tracking-[0.12em] text-[#9CA3AF] group-hover:text-[#D4AF37] transition-colors duration-300">
      <span className="block">INDEPENDENT MARKETING &amp;</span>
      <span className="block">INVESTMENT ADVISORY <span className="text-[#D4AF37]/70">· by HOMEWIZ.IN</span></span>
    </span>
  </a>
);
